import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
import { getCurrentPriceColor } from "./utils";
export var PricesSectionWrapper = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    fontSize: 14,
    maxHeight: 42,
    lineHeight: '21px',
    marginTop: 'auto',
    width: '100%'
  }, theme.breakpoints.down('md'), {
    fontSize: 10
  });
});
export var PricesHolder = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'flex',
    flexGrow: 1,
    gap: theme.spacing(2),
    justifyContent: 'flex-start'
  };
});
export var CurrentPrice = styled('div')(function (_ref4) {
  var oldPriceVisible = _ref4.oldPriceVisible,
    theme = _ref4.theme;
  return {
    color: getCurrentPriceColor(theme, oldPriceVisible),
    fontSize: theme.typography.pxToRem(14),
    overflow: 'hidden',
    fontWeight: theme.typography.fontWeightBold,
    maxWidth: '50%',
    textOverflow: 'ellipsis'
  };
});
export var PriceStartingFrom = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    fontStyle: 'italic',
    fontWeight: theme.typography.fontWeightBold,
    minWidth: '30%'
  };
});
export var OldPrice = styled('div')(function (_ref6) {
  var theme = _ref6.theme;
  return {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.grey.A700,
    overflow: 'hidden',
    maxWidth: '50%',
    textOverflow: 'ellipsis',
    textDecoration: 'line-through'
  };
});
//# sourceMappingURL=styles.js.map